import { RouterProvider } from "react-router";
import { router } from "./routes";
import { AuthProvider } from "../lib/auth/AuthProvider";
import { OrgProvider } from "../lib/org";
import { ViewScopeProvider } from "../lib/scope";
import { ThemeProvider } from "../lib/theme";
import { RootErrorBoundary } from "./components/RootErrorBoundary";
import { PlausiblePageviews } from "../lib/telemetry/analytics";

export default function App() {
  return (
    <RootErrorBoundary>
      <ThemeProvider>
        <AuthProvider>
        <OrgProvider>
          {/*
            Wave 20: view-scope state lives inside <OrgProvider> (so it can
            read `activeRole` for role-locking) and above <RouterProvider>
            (so every route gets the same instance). It syncs with the URL
            via plain `window.history` + `popstate`, which means it doesn't
            need router context — a deliberate choice so the provider tree
            stays flat.
          */}
          <ViewScopeProvider>
            {/*
              `PlausiblePageviews` hooks `history.pushState` globally, so it
              only needs to be mounted once anywhere in the React tree. We keep
              it as a sibling of `RouterProvider` (rather than trying to nest
              it inside — v7's `RouterProvider` takes no children) which keeps
              the router wiring in `routes.tsx` untouched.
            */}
            <PlausiblePageviews />
            <RouterProvider router={router} />
          </ViewScopeProvider>
        </OrgProvider>
      </AuthProvider>
      </ThemeProvider>
    </RootErrorBoundary>
  );
}
